import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import UniversalSelect from "./UniversalSelect";

export default class Select extends Component {

  _instances = {};

  configure() {
    return super.configure();
  }

  initialize() {
    this.elements = $('.is-uni-select');
    this.start();
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.App.Events.subscribe('form.refreshed', () => {
      return this.start();
    });
  }

  start() {

    this.elements.each((index, element) => {
      return this.prepare($(element));
    });

  }

  prepare(element) {

    if (element.find('.choices').length > 0)
      return true;

    // Populate config
    let config = this.populateConfig(element);

    // Save instance
    let instance = this.instance(element, config);
    if (typeof config.type == 'string') {
      this.addInstance(config.type, instance);
    }

  }

  populateConfig(element) {

    let input = element.find('select');

    let config = {
      input:            input,
      isWithError:      input.closest('.field').next('.help.is-danger').length > 0,
      isMultiple:       input.attr('multiple') === 'multiple',
      name:             input.attr('name') || null,
      type:             input.data('type') || null,
      placeholder:      input.data('placeholder') || null,
      target:           (input.data('target') || '').split(',') || [],
      targetType:       input.data('targetType') || null,
      allowCustomItems: input.data('allowCustomItems') || false,
      remoteUrl:        input.data('remoteUrl') || null,
      remoteParam:      input.data('remoteParam') || 'query',
      searchAjaxFn:     null,
      isWithSearch: (
        // TODO: language template condition
        parseInt(input.data('isWithSearch')) === 1
        || input.data('isWithSearch') == null
      ),
      template:     input.data('template') || null
    };

    // Support for ajax search
    if (config.remoteUrl != null && config.remoteUrl.length > 0) {
      config.searchAjaxFn = this.onSearch(config.remoteUrl, config.remoteParam);
    }

    // Disable search for language choose
    if (config.template === 'language') {
      config.isWithSearch = false;
    }

    return config;
  }

  onSearch(remoteUrl, remoteParam) {

    return (value, callback) => {

      if (remoteUrl != null && remoteUrl.length > 0) {

        let params = {};
        params[remoteParam] = value;

        return this.App.API.get(remoteUrl, params).catch((error) => {
          return this.App.UI.Dialog.alert(
            this.App.Language.get('errors.internal_error')
          );
        }).then((response) => {

          if (response.data) {

            this.logger('onSearch response:', response.data);

            if (typeof response.data.data == 'object') {
              // console.log(response.data.data);
              if (response.data.data.length > 0) {
                return callback(response.data.data, 'id', 'label');
              } else {
                //return choices._clearChoices();
              }
            }

          } else {
            return this.App.UI.Dialog.alert(
              this.App.Language.get('errors.internal_error')
            );
          }

        });

      }

    };
  }

  get instances() {
    return this._instances;
  }

  getInstance(name) {
    return this.instances[name] || null;
  }

  addInstance(name, instance) {
    // this.logger(`Add instance[${name}]:`, instance);
    this._instances[name] = instance;
  }

  instance(element, config) {
    return new UniversalSelect(element, config, {
      events: this.App.Events,
      manager: this,
    });
  }

}